import { Component, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { MycredentialsService } from './mycredentials.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
import { MycredentialmodalComponent } from '../../directives/mycredentialmodal/mycredentialmodal.component';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
@Component({
  selector: 'app-mycredentials',
  templateUrl: './mycredentials.component.html',
  styleUrls: ['./mycredentials.component.css']
})
export class MycredentialsComponent {
  @ViewChild('dt') dt: any;
  CSRFToken = '';
  items: MenuItem[] | undefined;
  tablecount: number = 0;
  dataListArray: Array<any> = [];
  exceldownloadModal = false;
  categorylist: any;
  ref: DynamicDialogRef | undefined;
  categoryScrollHeight = '';
  firstpage: number = 1;
  rows: number = 10;
  totalRecords: number = 0;
  options = [{ label: 10, value: 10 }];
  paginatorArray = [];
  position = 'top';
  excel_paragraph = '';
  downloadformate = false;
  templatedownloadtext = '';
  rowsize: number = 10;
  currentPageIndex: number = 0;
  customSort: boolean = true;
  searchTerm: string = ''; 

  constructor(
    public router: Router, public utilityserv: Utilityservice,
    public dialogService: DialogService, private MycredentialsService: MycredentialsService, private spinner: NgxSpinnerService,
    public PagehelpmodalService: PagehelpmodalService
  ) {
    this.excel_paragraph = this.MycredentialsService.downloadexcel_text

  }
  ngOnInit() {
    this.categoryScrollHeight = this.utilityserv.scrollHeight
    this.getList();
    this.rows = this.MycredentialsService.getCredentialRowsPerPage();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.categoryScrollHeight = this.utilityserv.updateScrollHeight();
  }


  dismiss() {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Saved!", "", "success");
        this.ref.close();
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved!", "", "info");
        this.ref.close();
      }
    });
  }


  getList() {
    this.spinner.show();
    const currentPageSize = this.rowsize;

    this.MycredentialsService.getCredentialList().subscribe({
      next: (data: any) => {
        this.spinner.hide();

        let list = [];

        // FIX: Extract array from nested response
        if (Array.isArray(data)) {
          list = data;
        } else if (Array.isArray(data?.response)) {
          list = data.response;
        } else if (Array.isArray(data?.response?.response)) {
          list = data.response.response;
        }

        // Now assign extracted list
        this.dataListArray = list.map(item => ({
          ...item,
          isSelect: false
        }));

        this.options = this.utilityserv.getOptionDropdown(this.dataListArray.length);
        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.dataListArray.length;
        this.tablecount = this.dataListArray.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },

      error: (error) => {
        this.spinner.hide();
        Swal.fire({
          title: error.error?.error || "Error!",
          text: `This error occurred at: ${new Date().toLocaleString()}`,
          icon: "error",
        });
      }
    });
  }




  // getData() {
  //   this.spinner.show();
  //   const currentPageSize = this.rows;

  //   this.MycredentialsService.getCredentialList().subscribe((data: any) => {
  //     this.spinner.hide();

  //     let list = [];

  //     if (Array.isArray(data)) {
  //       list = data;
  //     }
  //     else if (data?.response && Array.isArray(data.response)) {
  //       list = data.response;
  //     }
  //     else if (data?.response?.response && Array.isArray(data.response.response)) {
  //       list = data.response.response;
  //     }

  //     this.dataListArray = list;

  //     if (!Array.isArray(this.dataListArray)) {
  //       this.dataListArray = [];
  //     }

  //     this.options = this.utilityserv.getOptionDropdown(this.dataListArray.length);
  //     this.paginatorArray = this.options.map(e => e.value);

  //     this.dataListArray = this.dataListArray.map(e => ({
  //       ...e,
  //       isSelect: false
  //     }));

  //     if (!this.paginatorArray.includes(currentPageSize)) {
  //       this.paginatorArray.push(currentPageSize);
  //       this.paginatorArray.sort((a, b) => a - b);
  //     }

  //     this.rows = currentPageSize;
  //     this.totalRecords = this.dataListArray.length;
  //   });
  // }



  show(title, data) {
    let details = {};
    this.currentPageIndex = this.dt?.first || 0;
    if (title === 'Modify Credential') {
      this.MycredentialsService.getCredentialById(data.rid).subscribe((res: any) => {
        if (res.length === 0) {
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(MycredentialmodalComponent, {
            header: title,
            width: '50vw',
            height: 'auto',

            data: { title: title, datas: details },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
          });
          this.ref.onClose.subscribe(() => {
            this.getList();
          });
        }
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(MycredentialmodalComponent, {
        header: title,
        width: '50vw',
        height: 'auto',

        data: { title: title, datas: details },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 10000,
      });
      this.ref.onClose.subscribe(() => {
        this.getList();
      });
    }
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  exceDownloadModel() {
    let payload = {}
    const width = this.utilityserv.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: {
        excelname: "My Credentials.xlsx", downloadapi: 'common/mycredential/getexcel',
        method: 'get', message: this.excel_paragraph, payload: payload
      },
      contentStyle: { overflow: 'hidden' },
      maximizable: false,
      position: 'center'

    })
  }

  deleteCredential(rid: any) {
    Swal.fire({
      title: 'Are you sure you want to delete this credential?',
      text: 'Once deleted it cannot be recovered.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, I am sure',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {

        this.utilityserv.getCSRFtoken().subscribe(
          res => {
            const payload = {
              rid: rid,
              csrftoken: res.csrf,
            };
            this.MycredentialsService.deleteCredentials(payload).subscribe({
              next: () => {
                Swal.fire('Credentials deleted successfully!', '', 'success');
                this.getList();
              },
              error: (error) => {
                console.error('Error response:', error);
                Swal.fire('Error!', 'Something went wrong while deleting.', 'error');
              }
            });
          },
          err => {
            Swal.fire(err.error.message || "CSRF Token Error", '', 'error');
          }
        );
      }
    });
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }


}
